module.exports = "<div class=\"footer-background\">\n\t<p class=\"copyright\">\n\t\tCopyright 2019 Busso Ltda.\n\t</p>\n</div>\n"